<template>
  <div :class="state">
    <div class="footer">
      <div class="cover">
        <div class="wrapper">
          <div class="block" style="margin-top: .38rem">
            <div class="f-title">
              网站导航
            </div>
            <div class="f-nav">
              <span @click="target('Home')">首页</span>
              <span @click="target('About')">企业介绍</span>
              <span @click="target('Product')">产品中心</span>
              <span @click="target('News')">新闻中心</span>
              <span @click="target('Contact')">联系我们</span>
            </div>
          </div>
          <div class="block">
            <div class="f-title">
              合作方式
            </div>
            <div class="f-info">
              <div>联系电话：86-21-62054818</div>
              <div>公司地址：上海市嘉定区马陆镇丰饶路818号</div>
              <div>电子邮箱：lip@leeno.com.cn</div>
            </div>
          </div>
          <div class="block">
            <div class="left">
              <a target="_blank" href="https://www.leeno.com">  <span class="bt">总部企业网站</span></a>
            </div>
            <div class="right">
              <div class="copyright"> © Copyright©2010-2023 上海力普科技服务公司版权所有
              </div>
              <div class="copyright"> <a href="http://beian.miit.gov.cn" target="_blank">沪ICP备11027452号-1</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    const target  = (type) => {
        router.push(type)
    }
    const state = computed(() => useStore().state.client);

    return {
      target,
      state
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 1rem;
  height: 5.2rem;
  background-image: url("@/assets/images/banner/banner-2.jpg");
  background-size: cover;
  object-fit: contain;
  color: #fff;
  font-size: .14rem;
  clear: both;

  .block{
    margin-top: .5rem;
  }

  .cover {
    background: rgb(27 33 40 / 70%);
    position: absolute;
    height: 5.2rem;
    z-index: 888;
    width: 100%
  }

  .left{
    float: left;
    .bt{
      padding: .06rem .12rem;
      background: #3385ff;
      cursor: pointer;
      color: white;
      font-size: .15rem;
      font-weight: 600;
      border-radius: 7px;
    }
  }
  .right{
    float: right ;
    text-align: right;
  }
}

.mobile{
  .footer {
    margin-top: 1rem;
    height: 6.2rem;

    .block{
      margin-top: .3rem;

      .left{
        margin-top: .3rem;
        width: 100%;
        text-align: center;
      }

      .right{
        margin-top: .3rem;
        width: 100%;
        text-align: center;
      }
    }

    .cover {
      height: 6.2rem;
    }
  }
}

.footer .wrapper {
  width: 12rem;
  margin: 0 auto;

  .f-title {
    font-size: .22rem;
    font-weight: 600;
  }

  .f-nav {
    span {
      font-size: .16rem;
      font-weight: 400;
      cursor: pointer;
      margin-right: .3rem;
    }
  }

  .f-info {
    div {
      font-size: .16rem;
      font-weight: 400;
      cursor: pointer;
      margin-bottom: .1rem;
    }
  }
}

.footer .f-title {
  height: .7rem;
  line-height: .7rem;
  margin: 0
}

a:link {
  color: #ffffff
}

a:visited {
  color: #ffffff
}

a:hover {
  color: #ffffff
}
</style>
